import React, { Component } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import BankCards from 'modules/Payment/components/BankCards/BankCardsContainer';
import Loading from 'components/Loading';
import InfoMessage from 'components/InfoMessage/InfoMessage';
import Warning from 'components/Warning';

import styles from './PaymentInformation.module.scss';
import { SaveCardRedirectToBank } from 'modules/Profile/components/PaymentInformation/overrides/SaveCardRedirectToBank';
import HelpItemCollapse from 'modules/Help/components/HelpItemCollapse';
import Checkbox from 'components/Checkbox';
import Button from 'components/Button';
import * as scroller from 'utils/scroll';
import { fetchAcceptText } from 'modules/Payment/components/ConsentToProcessingPersonalData/fetchAcceptText';
import AutoTopupBlock from './AutoTopupBlock';

class PaymentInformation extends Component {
  state = {
    selectedCard: null,
    fetchOnPageFocus: false,
    agreeToProcessing: false,
    showAgreement: false,
    isLoading: false,
    acceptText: '',
  };

  agreementRef = React.createRef();

  componentDidMount() {
    window.addEventListener('visibilitychange', this.fetchUpdatedCardList);
    const { bankCards, getBankCards } = this.props;
    this.setAcceptText();
    if (!bankCards) {
      getBankCards();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('visibilitychange', this.fetchUpdatedCardList);
  }

  fetchUpdatedCardList = () => {
    if (document.visibilityState === 'visible' && this.state.fetchOnPageFocus) {
      this.props.getBankCards();
      this.setState({ fetchOnPageFocus: false, showAgreement: false, agreeToProcessing: false });
    }
  };
  handleSelect = (bankCard, handleForcePayment) => {
    if (!get(bankCard, 'id')) {
      this.setState({ fetchOnPageFocus: true });
      handleForcePayment();
    } else if (bankCard.isDefault) {
      this.setState({ selectedCard: bankCard });
    }
  };

  handleAddCard = () => {
    this.setState({ showAgreement: true });
    setTimeout(() => scroller.scrollTo('agreementRef', { smooth: true }), 0);
  };

  async setAcceptText() {
    this.setState({ isLoading: true });
    const acceptText = await fetchAcceptText();
    this.setState({ isLoading: false, acceptText });
  }

  render() {
    const { isCardsLoading, isCardsError, bankCards, configData } = this.props;
    const { agreeToProcessing, showAgreement, isLoading, acceptText } = this.state;
    if (isCardsError) {
      return <Warning />;
    }
    if ((isCardsLoading && !bankCards) || isLoading) {
      return <Loading />;
    }
    const recurrentBankCards =
      bankCards?.filter((bankCard) => {
        return bankCard.recurrent === 'Y';
      }) ?? [];

    return (
      <SaveCardRedirectToBank bankId={'gpb-extended'}>
        {({ handleForcePayment, loading, error }) => (
          <div className={'white-block__pad40 pt-0'}>
            <InfoMessage>Привязка карты происходит на стороне банка</InfoMessage>
            <div className={styles.BankCards}>
              <BankCards
                onSelectCard={(e) => this.handleSelect(e, this.handleAddCard)}
                selectedCard={this.state.selectedCard}
                isPayment={false}
                keepAddNewCard={true}
              />
            </div>
            {showAgreement && (
              <div>
                <HelpItemCollapse
                  title={'Соглашение об обработке персональных данных'}
                  content={acceptText}
                />
                <div id={'agreementRef'} className={styles.payButtonWrapper}>
                  <Checkbox
                    onChange={(value) => this.setState({ agreeToProcessing: value })}
                    value={agreeToProcessing}
                    isFull={true}
                    className={styles.checkboxStyle}
                    label="Я прочитал и даю согласие на обработку своих персональных данных"
                  />
                  <Button
                    onClick={handleForcePayment}
                    isDisabled={!agreeToProcessing}
                    type="submit"
                    size="big"
                    color={!agreeToProcessing ? 'blue' : 'orange'}
                    hasWrapper={false}
                  >
                    Привязать
                  </Button>
                </div>
              </div>
            )}
            {loading && <Loading />}
            {error && <Warning />}

            {!!recurrentBankCards?.length && !configData?.hiddenFeatures?.AUTOPAYMENT_ENP && (
              <AutoTopupBlock bankCards={recurrentBankCards} />
            )}
          </div>
        )}
      </SaveCardRedirectToBank>
    );
  }
}

PaymentInformation.propTypes = {
  bankCards: PropTypes.array,
  isCardsLoading: PropTypes.bool,
  isCardsError: PropTypes.bool,
  getBankCards: PropTypes.func.isRequired,
  configData: PropTypes.objectOf({
    hiddenFeatures: PropTypes.object,
  }),
};

export default PaymentInformation;
